import React from 'react';
import { Box} from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import { convertAddThsndDivider } from '../helpers/stringFormat';

const ValueModelSegmentsDisplay = ({ presentation, viewValueModel }) => {
    // Wait until the required data is available
    if (
        !presentation ||
        !presentation.customer_segments ||
        presentation.customer_segments.length === 0 ||
        viewValueModel.length === 0
    ) {
        return <div>Loading...</div>;
    }

    // Build the chart data by looping over customer_segments.
    // For each segment, the x-axis label is the segment name and the y-value is the sum of the drivers,
    // where each value is negative if positive_driver is false, and positive otherwise.
    const chartData = presentation.customer_segments.map((segment, index) => {
        const drivers = viewValueModel[index] || [];
        const sumValue = drivers.reduce((total, driver) => {
            return total + (driver.positive_driver ? driver.value : -driver.value);
        }, 0);
        return {
            name: segment.name, // used for the x-axis labels
            value: sumValue + presentation.product.price_alternative,    // summed up value for this segment
        };
    });

    return (
        <Box>
            <BarChart
                width={600}
                height={400}
                dataset={chartData}  // chartData is an array of objects with keys "name" and "value"
                series={[
                    {
                        dataKey: 'value',
                        label: 'Your Created Value',
                        color: '#696969',
                        // barLabel: ({ x, y, width, height }) => (
                        //     <text
                        //         x={x + width / 2}
                        //         y={y + height / 2}
                        //         textAnchor="middle"
                        //         dominantBaseline="middle"
                        //     >
                        //         Your Created Value
                        //     </text>
                        // ),
                    },
                ]}
                barLabel={item => {
                    return (
                        item.value > 0 ? `${'€'}${convertAddThsndDivider(item.value || '0')}` : `-${'€'}${convertAddThsndDivider(Math.abs(item.value) || '0')}`
                    )
                }}
                margin={{ left: 200 }}
                // x-axis is the value axis for horizontal layout
                xAxis={[{ scaleType: 'linear', valueFormatter: (value) => value >= 0 ? `${'€'}${convertAddThsndDivider(value || '0')}` : `-${'€'}${convertAddThsndDivider(Math.abs(value) || '0')}` }]}
                // y-axis is the band axis for categories
                yAxis={[{ scaleType: 'band', dataKey: 'name' }]}
                layout="horizontal"
                tooltip={{ trigger: 'none' }}
                slotProps={{
                    legend: {
                        itemMarkWidth: 20,
                        itemMarkHeight: 12,
                        markGap: 5,
                        itemGap: 10,
                        labelStyle: {
                            fontSize: 11,
                        },
                        position: {
                            vertical: 'top', // or 'bottom'
                            horizontal: 'right', // or 'left'
                        },
                        direction: 'row', // Align items in a vertical column (if needed)
                        align: 'start', // Align the second line with the first line
                    }
                }}
                axisHighlight={{
                    y: 'none',
                  }}
            />
        </Box>
    );
};

export default ValueModelSegmentsDisplay;